<p-splitButton
  #splitOptions
  [label]="activeMenuLabel()"
  appendTo="body"
  [icon]="activeMenuIcon()"
  [model]="items"
  class="bfx-button-secondary-bold bfx-button-sm risk-dropdown"
  menuStyleClass="bfx-dashboard-menu"
  (onClick)="showMenu()"
>
</p-splitButton>
